module.exports = __webpack_public_path__ + "img/1699322326796-nib ratna.png.46210f71.webp";